module.exports = __webpack_public_path__ + "img/H02027-01.829bdef7.jpg";